/*
  Cesera Set-Kauf (Runde 34)

  Faengt den Kaufbutton der Set-PDP ab und legt statt des Set-Produkts die
  beiden echten Komponenten in den Warenkorb — Rolle + Gel, mit ihren echten
  SKUs. Nur so erkennt HyperSKU die Bestellung automatisch.

  Vier Dinge, die aus Runde 20 (`cesera-bundle.js`) uebernommen sind:
  1. Listener DELEGIERT am `document`, nicht am Formular — Dawn ersetzt
     `<product-form>` bei jedem Variantenwechsel serverseitig.
  2. `capture: true`, damit wir VOR Dawns eigenem Submit-Handler drankommen.
  3. Das Skript wird per DOMParser eingefuegter Sektionen nicht neu ausgefuehrt,
     deshalb genau einmal binden (Guard unten).
  4. Nach dem Hinzufuegen dieselben Sektionen aktualisieren, die Dawn auch
     aktualisiert — sonst zeigt der Cart-Drawer einen veralteten Stand.
*/
(function () {
  if (window.ceseraSetCartGebunden) return;
  window.ceseraSetCartGebunden = true;

  function marker(formular) {
    var sektion = formular.closest('.shopify-section') || document;
    return sektion.querySelector('[data-cesera-set]');
  }

  function fehlerZeigen(wrapper, text) {
    if (!wrapper) return;
    var feld = wrapper.querySelector('.product-form__error-message');
    if (feld) feld.textContent = text;
    wrapper.hidden = false;
  }

  document.addEventListener(
    'submit',
    function (ereignis) {
      var formular = ereignis.target;
      if (!formular || formular.getAttribute('data-type') !== 'add-to-cart-form') return;

      var m = marker(formular);
      if (!m) return; // keine Set-Seite -> Dawn macht weiter wie immer

      var ids = (m.getAttribute('data-cesera-set-items') || '')
        .split(',')
        .map(function (s) { return parseInt(s, 10); })
        .filter(function (n) { return n > 0; });
      if (ids.length !== 2) return;

      ereignis.preventDefault();
      ereignis.stopImmediatePropagation();

      var knopf = formular.querySelector('.product-form__submit');
      var wrapper = formular.closest('product-form')
        ? formular.closest('product-form').querySelector('.product-form__error-message-wrapper')
        : null;
      if (wrapper) wrapper.hidden = true;
      if (knopf) {
        knopf.setAttribute('aria-disabled', 'true');
        knopf.classList.add('loading');
        var spinner = knopf.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');
      }

      /*
        ⚠️ BUGFIX Runde 37: hier stand `formular.querySelector('[name="quantity"]')`.
        Das Mengenfeld liegt NICHT im <form> — es steht im Block `quantity_selector`
        und ist nur ueber das HTML-Attribut `form="…"` mit dem Formular assoziiert.
        `querySelector` findet es deshalb nie, `menge` war immer 1: wer den Stepper
        auf 2 stellte, bekam trotzdem ein Set. `formular.elements` folgt dagegen der
        Formular-Assoziation — denselben Weg geht Dawn mit `new FormData(this.form)`.
      */
      var mengenFeld = formular.elements ? formular.elements['quantity'] : null;
      var menge = mengenFeld ? parseInt(mengenFeld.value, 10) || 1 : 1;

      /*
        Nachschub-Staffel (Runde 37): Ist eine Stufe gewaehlt, traegt SIE die Mengen —
        `data-cesera-set-tier="<rollen>,<gel>"`, in der Reihenfolge von
        `data-cesera-set-items`. Der Stepper ist dann versteckt und multipliziert
        zusaetzlich (normalerweise mit 1). Ohne Stufen bleibt das Verhalten aus
        Runde 34: beide Positionen bekommen dieselbe Menge.
      */
      var sektion = formular.closest('.shopify-section') || document;
      var stufe = sektion.querySelector('[data-cesera-set-tier]:checked');
      var proPosition = null;
      if (stufe) {
        proPosition = (stufe.getAttribute('data-cesera-set-tier') || '')
          .split(',')
          .map(function (s) { return parseInt(s, 10); });
        if (proPosition.length !== ids.length || proPosition.some(function (n) { return !(n > 0); })) {
          proPosition = null;
        }
      }

      var positionen = ids.map(function (id, i) {
        var anzahl = proPosition ? proPosition[i] * menge : menge;
        return { id: id, quantity: anzahl, properties: { _set: 'cesera-narbenpflege-routine' } };
      });

      var koerper = { items: positionen };
      var drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        koerper.sections = drawer
          .getSectionsToRender()
          .map(function (s) { return s.id; })
          .join(',');
        koerper.sections_url = window.location.pathname;
        if (typeof drawer.setActiveElement === 'function' && knopf) drawer.setActiveElement(knopf);
      }

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify(koerper),
      })
        .then(function (antwort) { return antwort.json(); })
        .then(function (daten) {
          if (daten.status) {
            fehlerZeigen(wrapper, daten.description || daten.message || 'Bitte versuche es erneut.');
            return;
          }
          if (drawer && typeof drawer.renderContents === 'function') {
            if (drawer.classList) drawer.classList.remove('is-empty');
            drawer.renderContents(daten);
          } else {
            window.location = window.Shopify.routes.root + 'cart';
          }
        })
        .catch(function () {
          fehlerZeigen(wrapper, 'Der Warenkorb konnte nicht aktualisiert werden.');
        })
        .finally(function () {
          if (knopf) {
            knopf.classList.remove('loading');
            knopf.removeAttribute('aria-disabled');
            var sp = knopf.querySelector('.loading__spinner');
            if (sp) sp.classList.add('hidden');
          }
        });
    },
    true
  );
})();
